<div class="banner"
  *transloco="let t; lang: 'en|static' read: 'directory_accdirectors_com.banner'">

  <div class="jumbotron">
    <div class="wrapper content">
      <div class="jumbo-content">
        <h2>{{ t('title') }}</h2>
        <p>{{ t('subtitle') }}</p>
      </div>
    </div>
  </div>
</div>
